import { v4 as uuid } from 'uuid';

const HOST_LOADED_CORRELATIONS = new Map<string, string>();

/**
 * Mint and cache the Loaded event's `correlationId` for a host
 * node. Viewed and Clicked must not reuse this value as their own
 * `correlationId` — they join through `viewCorrelationId` instead.
 */
export const ensureHostElementCorrelation = (
  stableKey: string | undefined,
): string => {
  if (!stableKey) {
    return uuid();
  }
  const existing = HOST_LOADED_CORRELATIONS.get(stableKey);
  if (existing) {
    return existing;
  }
  const correlationId = uuid();
  HOST_LOADED_CORRELATIONS.set(stableKey, correlationId);
  return correlationId;
};

export const getHostElementCorrelation = (
  stableKey: string | undefined,
): string | undefined =>
  stableKey ? HOST_LOADED_CORRELATIONS.get(stableKey) : undefined;

/**
 * Fresh per-event `correlationId`, joined to Loaded via
 * `viewCorrelationId` when a Loaded id has already been stored.
 */
export const mintHostElementEventCorrelationId = (): string => uuid();

export const mintHostElementLifecycleCorrelation = (
  stableKey: string | undefined,
): {
  readonly correlationId: string;
  readonly viewCorrelationId?: string;
} => {
  const correlationId = uuid();
  const viewCorrelationId = getHostElementCorrelation(stableKey);
  return viewCorrelationId === undefined
    ? { correlationId }
    : { correlationId, viewCorrelationId };
};

export const resetHostElementCorrelationsForTests = (): void => {
  HOST_LOADED_CORRELATIONS.clear();
};
